// pix-parcelado.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";

import { PixSimulationForm } from "./PixSimulationForm";
import { PixSimulationTable } from "./PixSimulationTable";
import { PixPaymentForm } from "./PixPaymentForm";
import { pixSimulate, payInstallmentPix } from "../../../../services/pix.service";
import { PageHeader } from "../../../page-header";

export function PixParcelado() {
  const [amount, setAmount] = useState(null);
  const [installmentsData, setInstallmentsData] = useState(null);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [step, setStep] = useState("SIMULATION");
  // SIMULATION | PAYMENT

  async function handleSimulate(amount) {
    const response = await pixSimulate({ amount });
    setAmount(amount);
    setInstallmentsData(response.data);
    setSelectedSimulation(null);
    setStep("SIMULATION");
  }

  function openContracts() {
    setStep("CONTRACTS");
  }

  function backToSimulation() {
    setStep("SIMULATION");
  }

  function handleSelectSimulation(simulation) {
    setSelectedSimulation(simulation);
  }

  function handleContinue() {
    if (!selectedSimulation) return;
    setStep("PAYMENT");
  }

  async function handleConfirmPayment(pixKey, pixKeyType, description, mfaCode, searchProtocol) {
    return payInstallmentPix({
      amount,
      installments: selectedSimulation.installments,
      pixKey,
      pixKeyType,
      searchProtocol,
      description,
      otp: mfaCode,
    });
  }

  async function onBack() {
    setStep("SIMULATION");
    setSelectedSimulation(null);
    setInstallmentsData(null);
    setAmount(null);
  }

  return (
    <div className="transferencia-ted">
      <div className="transferencia-ted-container col-md-10">
        {/* HEADER */}
        <div className="mt-4 mb-3">
          <PageHeader title="Pix Parcelado" pages={[{ name: 'Pix Parcelado', link: "/pagina-pix-parcelado" }]} />
        </div>

        {/* BODY */}
        <main className="max-w-3xl mx-auto px-4 py-6 space-y-6">
          {/* ETAPA 1 – SIMULAÇÃO */}
          {step === "SIMULATION" && (
            <>
              {!installmentsData && (
                <PixSimulationForm
                  onSimulate={handleSimulate}
                  onOpenContracts={openContracts}
                />
              )}

              {installmentsData && (
                <PixSimulationTable
                  amount={amount}
                  simulations={installmentsData.simulations}
                  monthlyInterest={installmentsData.interestRate}
                  selectedSimulation={selectedSimulation}
                  onSelect={handleSelectSimulation}
                  onContinue={handleContinue}
                  onBack={onBack}
                />
              )}
            </>
          )}

          {step === "PAYMENT" && (
            <PixPaymentForm
              selectedSimulation={selectedSimulation}
              amount={amount}
              onConfirm={handleConfirmPayment}
              onBack={onBack}
            />
          )}
        </main>
      </div>
    </div>
  );
}
